export const isCashierUser = (user) => {
  if (!user) return false;
  const roleMatch = user?.roles?.some?.((r) => r.name === 'Cashier');
  const perms = user?.permissions || [];
  const required = ['sales:create', 'refunds:create', 'tills:manage'];
  const forbidden = [
    'stores:read',
    'stores:update',
    'roles:manage',
    'settings:manage',
    'reports:view',
    'products:create',
    'products:update',
    'products:delete',
    'promotions:create',
    'promotions:update',
    'promotions:delete',
  ];
  const hasRequired = required.every((p) => perms.includes(p));
  const hasForbidden = forbidden.some((p) => perms.includes(p));
  return Boolean(roleMatch || (hasRequired && !hasForbidden));
};
